import React from 'react'
import { Helmet } from 'react-helmet-async'
import Landing from './Landing'
import Text from './Text'

const Blogs = () => {
    return (
        <>
            <Helmet>
                <title>ESG, CBAM & Sustainability Insights Blog | Nirantara</title>
                <meta name="description" content="Explore expert insights on ESG strategy, CBAM compliance, Scope 3 emissions, LCA, sustainability reporting, circular economy, and climate risk. Stay informed with practical guidance from Nirantara." />
                <meta name="keywords" content="ESG blog, sustainability insights, CBAM compliance blog, Scope 3 emissions explained, LCA sustainability articles, ESG reporting guidance, climate risk insights, circular economy blog, sustainability strategy articles" />
                <link rel="canonical" href="https://nirantara.solutions/blogs" />
            </Helmet>
      <h1 className="sr-only">Latest Blogs</h1>
            <div className="w-full md:mb-20 mb-8 flex flex-col items-center gap-8  montserrat ">
                <Landing />
                <Text />
            </div>
        </>
    )
}

export default Blogs
